import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import '../styles/studio-pilates.min.css';
import FotoOsteoVitta1 from '../assets/FotoEstudio1.jpeg';
import Img1 from '../assets/pilates-image-studio-carousel-01.png';
import Img2 from '../assets/pilates-image-studio-carousel-02.png';
import Img3 from '../assets/pilates-image-studio-carousel-03.png';
import Img4 from '../assets/chair.png';
const Slider = React.lazy(() => import("react-slick"));

export default function Home() {

    const settingsMobile = {
        infinite: true,
        slidesToShow: 1,
        dots: false,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        responsive: [
        {
            breakpoint: 1024,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            },
        },
        {
            breakpoint: 760,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            },
        },
        ],
    };

    const settingsDesktop = {
        infinite: true,
        slidesToShow: 3,
        dots: false,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        responsive: [
        {
            breakpoint: 1024,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            },
        },
        {
            breakpoint: 760,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            },
        },
        ],
    };

   return (
    <>
        <Helmet>
            <title>OsteoVitta Pilates - Criciúma</title>
            <link rel="canonical" href="https://www.osteovitta.com.br/equipamentos" />
            <meta name="description" content="Descubra os benefícios do Pilates na OsteoVitta em Criciúma" />
        </Helmet>

        <main className='studio-pilates'>

            <section className="pilates-studio-top">
                <h1>Studio de <span>Pilates</span></h1>

                <div className="pilates-studio-top-img">
                    <img src={FotoOsteoVitta1}/>
                </div>
            </section>

            <section className="pilates-custo-descricao">
                <h2>
                    Pratique pilates com segurança em equipamentos modernos. São infinitas as possibilidades de exercícios.
                </h2>

                <p>
                    O Pilates está entre as modalidades de atividade física de maior grau de satisfação dos praticantes. Os
                    benefícios físicos comprovados e a atenção individualizada aos alunos durante a prática são um grande
                    diferencial em relação a muitas outras atividades.
                    <br/><br/>
                    Diferentemente das aulas de Mat Pilates, as aulas em um Studio de Pilates são realizadas com a utilização de
                    equipamentos diversos e que possibilitam o desenvolvimento de uma infinidade de exercícios. Todos os
                    equipamentos utilizados no Studio de Pilates são completamente ajustáveis às características de qualquer
                    tipo físico. Aspectos como a amplitude do movimento, ângulo de trabalho e a intensidade da sobrecarga
                    muscular são individualizados, o que resulta não apenas na eficiência do exercício, mas também em um maior
                    conforto e segurança durante sua prática.
                    <br/><br/>
                    Dentre os principais equipamentos, podemos destacar 4: Reformer, Cadillac, Ladder Barrel e Chair.
                </p>
            </section>

            <section className="pilates-studio-equipamento pilates-studio-equipamento-mobile">
                <Slider {...settingsMobile} >
                    <div>
                        <ul className="sliderStudio">
                            <li>
                                <div className="pilates-studio-equipamento-container">
                                    <div className="pilates-studio-equipamento-img">
                                        <img src={Img1}/>
                                    </div>
                                    <div className="pilates-studio-equipamento-text">
                                        <h2>Cadillac</h2>
                                        <p className="equip-desc">
                                            O Cadillac é frequentemente o equipamento que causa maior impressão em alguém que entra pela
                                            primeira vez em um estúdio. Ele possibilita a execução de exercícios incríveis ao adicionar o
                                            desafio da gravidade ao seu programa, sendo um dos mais efetivos e versáteis equipamentos
                                            desenvolvidos até hoje.
                                        </p>

                                        <a href="/equipamentos/cadillac" className="link">saiba mais</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    
                    <div>
                        <ul className="sliderStudio">
                            <li>
                                <div className="pilates-studio-equipamento-container">
                                    <div className="pilates-studio-equipamento-img">
                                        <img src={Img2}/>
                                    </div>
                                    <div className="pilates-studio-equipamento-text">
                                        <h2>Reformer</h2>
                                        <p className="equip-desc">
                                            O Reformer é um equipamento de resistência desenvolvido por Joseph Pilates. Ele consiste em uma
                                            plataforma que se move para frente e para trás sobre rodinhas, ao longo de um trilho. A resistência
                                            é fornecida pelo peso do corpo da pessoa e por molas conectadas a plataforma e a barra fixa de
                                            molas.
                                            <br/><br/>
                                            O reformer possibilita uma enorme quantidade de exercícios, que trabalham tanto o centro (abdômen)
                                            do corpo quanto os músculos dos braços e pernas.
                                        </p>

                                        <a href="/equipamentos/reformer" className="link">saiba mais</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    
                    <div>
                        <ul className="sliderStudio">
                            <li>
                                <div className="pilates-studio-equipamento-container">
                                    <div className="pilates-studio-equipamento-img">
                                        <img src={Img3}/>
                                    </div>
                                    <div className="pilates-studio-equipamento-text">
                                        <h2>Ladder Barrel</h2>
                                        <p className="equip-desc">
                                            Uma das melhores maneiras de se fortalecer os músculos das costas através de execícios de extensão,
                                            o Ladder Barrel tem muitos usos. Ele é uma peça única de equipamento que permite com grande
                                            segurança a execução de exercícios de flexão e extensão das costas. Ele é também um ótimo
                                            fortalecedor geral.
                                        </p>

                                        <a href="/equipamentos/barrel" className="link">saiba mais</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <ul className="sliderStudio">
                            <li>
                                <div className="pilates-studio-equipamento-container">
                                    <div className="pilates-studio-equipamento-img">
                                        <img src={Img4 }/>
                                    </div>
                                    <div className="pilates-studio-equipamento-text">
                                        <h2>Chair</h2>
                                        <p className="equip-desc">
                                            Assim como o Reformer, o Pilates Chair é mais uma das "máquinas de resistência de Joseph Pilates". Ela é basicamente uma caixa com um lado que pode ser pressionado para baixo contra a resistência de molas, como um grande pedal. Algumas vezes, o pedal é dividido em 2 partes que podem trabalhar independentemente.
                                        </p>

                                        <a href="/equipamentos/chair" className="link">saiba mais</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </Slider>
            </section>

            <section className="pilates-studio-equipamento pilates-studio-equipamento-desktop">
                <Slider {...settingsDesktop} >
                    <div>
                        <ul className="sliderStudio">
                            <li>
                                <div className="pilates-studio-equipamento-container">
                                    <div className="pilates-studio-equipamento-img">
                                        <img src={Img1}/>
                                    </div>
                                    <div className="pilates-studio-equipamento-text">
                                        <h2>Cadillac</h2>
                                        <p className="equip-desc">
                                            O Cadillac é frequentemente o equipamento que causa maior impressão em alguém que entra pela
                                            primeira vez em um estúdio. Ele possibilita a execução de exercícios incríveis ao adicionar o
                                            desafio da gravidade ao seu programa, sendo um dos mais efetivos e versáteis equipamentos
                                            desenvolvidos até hoje.
                                        </p>

                                        <a href="/equipamentos/cadillac" className="link">saiba mais</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    
                    <div>
                        <ul className="sliderStudio">
                            <li>
                                <div className="pilates-studio-equipamento-container">
                                    <div className="pilates-studio-equipamento-img">
                                        <img src={Img2}/>
                                    </div>
                                    <div className="pilates-studio-equipamento-text">
                                        <h2>Reformer</h2>
                                        <p className="equip-desc">
                                            O Reformer é um equipamento de resistência desenvolvido por Joseph Pilates. Ele consiste em uma
                                            plataforma que se move para frente e para trás sobre rodinhas, ao longo de um trilho. A resistência
                                            é fornecida pelo peso do corpo da pessoa e por molas conectadas a plataforma e a barra fixa de
                                            molas.
                                            <br/><br/>
                                            O reformer possibilita uma enorme quantidade de exercícios, que trabalham tanto o centro (abdômen)
                                            do corpo quanto os músculos dos braços e pernas.
                                        </p>

                                        <a href="/equipamentos/reformer" className="link">saiba mais</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    
                    <div>
                        <ul className="sliderStudio">
                            <li>
                                <div className="pilates-studio-equipamento-container">
                                    <div className="pilates-studio-equipamento-img">
                                        <img src={Img3}/>
                                    </div>
                                    <div className="pilates-studio-equipamento-text">
                                        <h2>Ladder Barrel</h2>
                                        <p className="equip-desc">
                                            Uma das melhores maneiras de se fortalecer os músculos das costas através de execícios de extensão,
                                            o Ladder Barrel tem muitos usos. Ele é uma peça única de equipamento que permite com grande
                                            segurança a execução de exercícios de flexão e extensão das costas. Ele é também um ótimo
                                            fortalecedor geral.
                                        </p>

                                        <a href="/equipamentos/barrel" className="link">saiba mais</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <ul className="sliderStudio">
                            <li>
                                <div className="pilates-studio-equipamento-container">
                                    <div className="pilates-studio-equipamento-img">
                                        <img src={Img4 }/>
                                    </div>
                                    <div className="pilates-studio-equipamento-text">
                                        <h2>Chair</h2>
                                        <p className="equip-desc">
                                            Assim como o Reformer, o Pilates Chair é mais uma das "máquinas de resistência de Joseph Pilates". Ela é basicamente uma caixa com um lado que pode ser pressionado para baixo contra a resistência de molas, como um grande pedal. Algumas vezes, o pedal é dividido em 2 partes que podem trabalhar independentemente.
                                        </p>

                                        <a href="/equipamentos/chair" className="link">saiba mais</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </Slider>
            </section>

        </main>
    </> 
  );
}